import { memo } from 'react';

import { ITransportDescriptor } from '@mopla/utils';

import { TransportCircle } from './TransportCircle';
import { Root, TIconSize } from './TravelTypeSymbols.styles';

export interface TravelTypeSymbolsProps {
	transport: ITransportDescriptor | ITransportDescriptor[];
	variant?: 'midGrey' | 'main' | 'disabled';
	size?: TIconSize;
}

export const TravelTypeSymbols = memo<TravelTypeSymbolsProps>(
	({ transport, variant = 'main', size = 'small' }) => {
		const _transport = Array.isArray(transport) ? transport : [transport];

		return (
			<Root>
				{_transport.map(({ transportType, vehicleType }, index) => (
					<TransportCircle
						key={index}
						variant={variant}
						transportType={transportType}
						vehicleType={vehicleType}
						size={size}
					/>
				))}
			</Root>
		);
	}
);
